// src/components/surveys/questions/DateQuestion.tsx
import React from 'react';
import { SurveyQuestion } from '../../../types/survey.types';
import { Calendar } from 'lucide-react';

interface DateQuestionProps {
  question: SurveyQuestion;
  value?: string | null;
  onChange?: (value: string) => void;
  disabled?: boolean;
  showValidation?: boolean;
  error?: string;
  mode?: 'edit' | 'preview' | 'response';
}

const DateQuestion: React.FC<DateQuestionProps> = ({
  question,
  value,
  onChange,
  disabled = false,
  showValidation = false,
  error,
  mode = 'response',
}) => {
  const minDate = question.validation?.minDate;
  const maxDate = question.validation?.maxDate;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  if (mode === 'edit') {
    return (
      <div className="space-y-2">
        <div className="text-sm text-gray-500">Date picker preview:</div>
        <div className="relative">
          <input
            type="date"
            className="w-full p-3 border border-gray-200 rounded-lg bg-gray-50"
            disabled
          />
          <Calendar className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
        </div>
        <div className="text-xs text-gray-400">
          {minDate && `Min: ${minDate}`}
          {minDate && maxDate && ' | '}
          {maxDate && `Max: ${maxDate}`}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="relative">
        <input
          type="date"
          value={value || ''}
          onChange={handleChange}
          disabled={disabled}
          min={minDate}
          max={maxDate}
          className={`w-full p-3 border-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
            error
              ? 'border-red-300 focus:border-red-500'
              : value
              ? 'border-indigo-500 bg-indigo-50'
              : 'border-gray-200'
          } ${disabled ? 'bg-gray-50 cursor-not-allowed' : 'bg-white cursor-pointer'}`}
        />
      </div>
      {showValidation && error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default DateQuestion;
